import {Entity} from '@s-ui/domain'

/**
 * TechDebt: Contract should not be domain object.
 * contractId is the ID of a dealer, so Dealer Entity should be used
 */
export class ContractEntity extends Entity {
  /**
   * @constructor
   * @param {Object} data
   * @param {String} data.id
   * @param {Boolean} data.isPrivate
   * @param {Boolean} data.isProfessional
   */

  /**
   * Validation method
   * @param {Object} param
   * @param {String} param.id
   * @param {DealerError} param.invalidContractErrorFactory
   */
  static validate({id, invalidContractErrorFactory}) {
    const hasId = Boolean(id)

    if (!hasId) {
      throw invalidContractErrorFactory('[ContractEntity] Contract has not an ID')
    }
  }

  get isProfessional() {
    return this._isProfessional
  }

  get isPrivate() {
    return this._isPrivate
  }
}
